import React from 'react';

var Required = () => /*#__PURE__*/React.createElement("span", {
  className: "text-danger ps-1"
}, "*");

Required.displayName = "Required";
export default Required;